import React, { createContext, useContext, useState, useCallback } from "react";
import { Snackbar } from "@mui/material";
import CustomSnackbar from "../components/CustomSnackbar/CustomSnackbar";

// Created a Context for the Snackbar
const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  // State to manage the snackbar properties
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  // Function to show the snackbar with a message and severity
  const showSnackbar = useCallback((message, severity = "info") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  }, []);

  // Function to close the snackbar
  const closeSnackbar = useCallback(() => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  // Handle the Snackbar close event
  const handleClose = (event, reason) => {
    // Check if the reason is the close button (close icon)
    if (reason === 'clickaway') {
      return; // Don't close the Snackbar
    }
    // Close the Snackbar
    closeSnackbar();
  };

  return (
    // Provide the showSnackbar and closeSnackbar functions to the context consumers
    <SnackbarContext.Provider value={{ showSnackbar, closeSnackbar }}>
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        disableWindowBlurListener={true}
        onClose={handleClose}
        anchorOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
      >
        <div>
          <CustomSnackbar
            variant={snackbar.severity}
            message={snackbar.message}
            onClose={handleClose}
          />
        </div>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

// Custom hook to use the Snackbar context
export const useSnackbar = () => {
  return useContext(SnackbarContext);
};
